import React from 'react';
import {connect} from 'react-redux';
import { Container, Col, Row } from 'reactstrap';

import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';

//store functions
import {initTechnicianUpdates, resetBlock, setTitle, setIsShowErrorPopup} from './TechnicianUpdatesBlockSlice';

//pages
import CustomerVisitInfoPage from './Pages/CustomerVisitInfoPage';
import TechnicianTimeSlotsPage from './Pages/TechnicianTimeSlotsPage';
import TechnicianTimeSlotsCellcomPage from './Pages/TechnicianTimeSlotsCellcomPage';
import ErrorPage from './Pages/ErrorPage';
import SuccessPage from './Pages/SuccessPage';

//popup
import ErrorPopUp from './Shared/ErrorPopUp/ErrorPopUp'


const TechnicianUpdates = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initTechnicianUpdates({technicianUpdatesBlock: props.iContent});
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();
  //--------------- useEffect ---------------

  switch (props.page) {
    case 'customerVisitInfoPage': 
    currentView = <CustomerVisitInfoPage/>; 
    props.setTitle("הטכנאים שמתואמים עבורך");
    break;
    case 'technicianTimeSlotsPage': 
    currentView = <TechnicianTimeSlotsPage/>; 
    props.setTitle("למתי תרצו שנקבע?");
    break;
    case 'technicianTimeSlotsCellcomPage':
    currentView = <TechnicianTimeSlotsCellcomPage/>; 
    props.setTitle("");
    break;
    case 'errorPage': 
    props.setTitle("");
    currentView = <ErrorPage context={props.context}/>; 
    break;
    case 'successPage':
    props.setTitle("העדכון בוצע בהצלחה");
    currentView = <SuccessPage/>; 
    break;
  }

  function closeErrorPopup(){
    props.setIsShowErrorPopup({isShow: false, type: ""});
  }

  return (
    <Container className='technician-update-wrapper'>
      <Row className="justify-content-md-center">
        <Col xs='12' sm='12' md='10' xl='6'>
          <h1 className="main-title">עדכון הגעת טכנאי</h1>
          <h2 className="main-sub-title">{props.title}</h2>
          {currentView}
        </Col>
      </Row>
      <ErrorPopUp closeErrorPopup={closeErrorPopup}/>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.technicianUpdatesBlock.page,
    title: state.technicianUpdatesBlock.title,
    errorPopup: state.technicianUpdatesBlock.errorPopup
  };
};

const mapDispatchToProps = {
    initTechnicianUpdates, 
    resetBlock,
    setTitle,
    setIsShowErrorPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianUpdates);
